import { useState } from "react";
import {
  ResponseGetNoticeResponse,
  NoticeApi,
  RequestDeleteNoticeRequest,
  NoticeDeleteNoticePostRequest,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiDeleteNotice = () => {
  const [noticeList, setNoticeList] = useState<
    ResponseGetNoticeResponse[] | null
  >([]);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const deleteNotice = async (req: RequestDeleteNoticeRequest) => {
    setIsLoading(true);
    setError(null);

    try {
      const config = createConfiguration();
      const request: NoticeDeleteNoticePostRequest = {
        req,
      };
      const api = new NoticeApi(config);
      const response = await api.noticeDeleteNoticePost(request);
      setNoticeList(response);
      return response;
    } catch (err: any) {
      setError("お知らせの削除に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { deleteNotice, noticeList, error, isLoading };
};
